import React from "react";
import LogNav from "../layout/LoggedNav";
import Tabs from "../layout/Tabs";
import Table from "../IncidentsLog/Table";
import SearchIcon from "../../assets/images/search/search_icon.svg"

const IncidentsLog_search= (props) => {
   const {searchKey,setSearchKey}=props
   const onChangeVlaue=(input)=>{
       setSearchKey(input.target.value)
   }
    return (
        <>
            <input className="form__input-md-wt" type="text" 
            placeholder="Type here to find a record in" 
            value={searchKey} onChange={onChangeVlaue} 
            // style={ {
            // // border: '1px solid #cbcbcb',
            // color: '#525252'
            //  }}
            />
        </>
    );
};
export default IncidentsLog_search;